module.exports = __webpack_public_path__ + "static/img/18.3a128d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/18.jpg
// module id = vb3G
// module chunks = 16